import { styled } from '@mui/material/styles';
import StepConnector, { stepConnectorClasses } from '@mui/material/StepConnector';
import AccountTreeIcon from '@mui/icons-material/AccountTree';
import InsertDriveFileIcon from '@mui/icons-material/InsertDriveFile';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import EqualizerIcon from '@mui/icons-material/Equalizer';
import DevicesIcon from '@mui/icons-material/Devices';

export const CustomConnector = styled(StepConnector)(({ theme }) => ({
    [`&.${stepConnectorClasses.vertical}`]: {
        marginLeft: 24,
    },
    [`& .${stepConnectorClasses.line}`]: {
        borderLeftWidth: 3,
        minHeight: 50,
        borderColor: '#eaeaf0',
        borderRadius: 1,
    },
    [`&.${stepConnectorClasses.active} .${stepConnectorClasses.line}`]: {
        borderColor: theme.palette.primary.main,
    },
    [`&.${stepConnectorClasses.completed} .${stepConnectorClasses.line}`]: {
        borderColor: theme.palette.primary.main,
    },
}));

export const CustomStepIconRoot = styled('div')(({ ownerState, theme }) => ({
    backgroundColor: '#ccc',
    zIndex: 1,
    color: '#fff',
    width: 50,
    height: 50,
    display: 'flex',
    borderRadius: '50%',
    justifyContent: 'center',
    alignItems: 'center',
    ...(ownerState.active && {
        backgroundImage: `linear-gradient(136deg, ${theme.palette.primary.main} 0%, ${theme.palette.primary.main} 50%, ${theme.palette.secondary.main} 100%)`,
    }),
    ...(ownerState.completed && {
        backgroundImage: `linear-gradient(136deg, ${theme.palette.primary.main} 0%, ${theme.palette.primary.main} 70%, ${theme.palette.secondary.main} 100%)`,
    }),
}));

// Export individual icons for dynamic use
export { AccountTreeIcon, InsertDriveFileIcon, AccessTimeIcon, EqualizerIcon, DevicesIcon };

export const containerStyles = {
    mt: 5,
    ml: 40
};

export const stepperStyles = {
    marginLeft: -20,
    '& .MuiStepLabel-root': {
        display: 'flex',
        alignItems: 'center',
    },
    '& .MuiStepLabel-label': {
        marginLeft: 2,
        fontWeight: 'normal',
        fontSize: '1.5rem',
    },
    '& .MuiStepLabel-label.Mui-active': {
        fontWeight: 'bold',
    },
    '& .MuiStepLabel-label.Mui-completed': {
        fontWeight: 'bold',
    },
    '& .MuiStepLabel-iconContainer': {
        paddingRight: 8,
        transform: 'scale(1.2)',
    },
    '& .MuiStepContent-root': {
        borderLeft: 'none',
        marginLeft: 16,
        paddingLeft: 0,
        textAlign: 'left',
        fontSize: '1.2rem',
    },
};

export const tooltipIconStyles = {
    ml: 1,
    color: 'darkgray'
}; 